import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FmvAttributeVisualizerComponent } from '../fmv-attribute-visualizer/fmv-attribute-visualizer.component';

@Component({
  selector: 'app-fmv-attribute-visualizer-modal',
  standalone: true,
  imports: [FmvAttributeVisualizerComponent],
  templateUrl: './fmv-attribute-visualizer-modal.component.html',
  styleUrl: './fmv-attribute-visualizer-modal.component.css'
})


export class FmvAttributeVisualizerModalComponent {
  @Input() type: 'adhoc' | 'live' | 'playback' = 'live';
  @Input() sensorId?: number;
  @Input() cameraSessionId?: number;
  @Input() number?: number;
  @Input() mode: 'LIVE' | 'PLAYBACK' = 'LIVE';
  @Input() startTime?: string;
  @Input() endTime?: string;
  @Input() cameraUrl?: string;
  @Input() camera?: any;

  constructor(public activeModal: NgbActiveModal) {}
}